<template>
  <t-divider>{{ t('signIn.actions.otherSignInMethods') }}</t-divider>
  <div class="sign-in-mode-selector">
    <UserCircleIcon v-if="appSettingStore.enableAccountLogin" class="icon" style="color:var(--td-brand-color);"
      @click="navToSignIn('/AccountPassword')" />
    <t-image v-if="appSettingStore.enableWXQRLogin || (supportsNativeWeChatAuth() && appSettingStore.enableWXNativeAppLogin)" fit="contain" src="./wx.png" class="icon"
      @click="navToSignIn('/WX')" />
    <t-image v-if="appSettingStore.enableQYWXQRLogin && !isInMobileApp()" fit="contain" src="./qywx.png" class="icon"
      @click="navToSignIn('/WXWork')" />
    <t-image v-if="appSettingStore.enableDingTalkLogin && !isInMobileApp()" fit="contain" src="./dingtalk.png" class="icon"
      @click="showDingTalk()" />
    <t-image v-if="appSettingStore.enableAlipayLogin" fit="contain" src="./alipay.png" class="icon"
      @click="showAlipay()" />
  </div>
</template>
<script setup lang="ts">
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';

import { UserCircleIcon } from 'tdesign-icons-vue-next'

import { useAppSettingStore, useSignInStore } from '../store/index_SignIn';
import { isInMobileApp, supportsNativeAlipayAuth, supportsNativeWeChatAuth } from '../utils/appDetection';

const router = useRouter();

const appSettingStore = useAppSettingStore();
const signInStore = useSignInStore();
const { t } = useI18n();

const navToSignIn = (path: string) => {
  router.push(path);
};

const showAlipay = () => {
  if (supportsNativeAlipayAuth()) {
    navToSignIn('/Alipay');
    return;
  }

  var challengeUrl = `./external/Challenge?provider=Alipay&callback=AlipayCallback&returnUrl=${signInStore.returnUrl}`;

  location.href = challengeUrl;
};

const showDingTalk = () => {
  var challengeUrl = `./external/Challenge?provider=DingTalk.建桥小星&returnUrl=${signInStore.returnUrl}`;

  location.href = challengeUrl;
};

</script>
<style lang="less" scoped>
.sign-in-mode-selector {
  display: flex;
  justify-content: center;
  gap: 16px;

  .icon {
    width: 40px;
    height: 40px;
    background-color: transparent;
    cursor: pointer;
  }
}
</style>
